import React, { useEffect, useState } from "react";
import defaultClasses from "./indicator.module.scss";
import Image from "../Image";
import { useAppContext } from "@overrides_venia/peregrine/context/app";
import { useLocation } from "@magento/venia-ui/lib/drivers";
import loadingPasta from "@Assets/images/loading_pasta.gif";
import logo_red from "../../../../assets/images/miscusi_logo_mobile_red.svg";
var LoadingIndicator = _ref => {
  var {
    message,
    color,
    global,
    width,
    height,
    src,
    classes,
    extraClasses
  } = _ref;
  var internlClasses = classes ? classes : defaultClasses;
  var className = global ? internlClasses.global : internlClasses.root;
  return /*#__PURE__*/React.createElement("div", {
    className: "indicator ".concat(className, " ").concat(extraClasses ? extraClasses : "")
  }, /*#__PURE__*/React.createElement(Image, {
    displayPlaceholder: false,
    alt: "Miscusi",
    height: height ? height : 60,
    width: width ? width : 60,
    src: src ? src : logo_red,
    title: "Miscusi",
    classes: {
      root: internlClasses.indicator ? internlClasses.indicator : defaultClasses.indicator
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "message ".concat(internlClasses.message),
    style: color ? {
      color: color
    } : {}
  }, message ? message : "what’s cookin’?"));
};
export var GlobalLoadingIndicator = () => {
  var [isReady, setIsReady] = useState(false);
  var [isAnimating, setIsAnimating] = useState(false);
  var [showLoadingIndicator, setShowLoadingIndicator] = useState(true);
  var [{
    isPageLoading,
    pageLoaderFlags
  }, {
    actions: {
      setPageLoaderFlag
    }
  }] = useAppContext();
  var [disableLoadingScreen] = useState(localStorage.getItem("disableLoadingScreen") === "true");
  var location = useLocation();
  useEffect(() => {
    // Simulate a delay for loading styles or other resources
    setTimeout(() => {
      setIsReady(true);
    }, 20); // Adjust this time based on your actual resource loading time
  }, []);
  useEffect(() => {
    if (!isPageLoading && showLoadingIndicator) {
      setIsAnimating(true);
      setTimeout(() => {
        setIsAnimating(false);
        setShowLoadingIndicator(false);
      }, 300);
    }
  }, [isPageLoading, showLoadingIndicator]);
  useEffect(() => {
    setPageLoaderFlag({
      name: "default",
      value: true
    });
    setShowLoadingIndicator(true);
    setTimeout(() => {
      setPageLoaderFlag({
        name: "default",
        value: false
      });
    }, 10000); // Adjust this time based on your actual resource loading time
  }, [location.pathname]);
  return isReady && showLoadingIndicator && !disableLoadingScreen ? /*#__PURE__*/React.createElement(LoadingIndicator, {
    global: true,
    width: 200,
    height: 200,
    src: loadingPasta,
    extraClasses: isAnimating ? "uk-animation-fade uk-animation-reverse" : ""
  }) : null;
};
export default LoadingIndicator;